import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { noteDocumentReloadIfAny } from '@/utils/predictListNav'

noteDocumentReloadIfAny()
import Region from 'v-region'
import ElementSwitch from 'element-ui/lib/switch'
import ElementDatePicker from 'element-ui/lib/date-picker'
import Message from 'element-ui/lib/message'
import MessageBox from 'element-ui/lib/message-box'
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/element-message.css';
import VantCheckbox from 'vant/lib/checkbox'
import VantDialog from 'vant/lib/dialog'
import VantLoading from 'vant/lib/loading'
import VantPicker from 'vant/lib/picker'
import VantPopup from 'vant/lib/popup'
import VantPullRefresh from 'vant/lib/pull-refresh'
import VantSlider from 'vant/lib/slider'
import VantSwitch from 'vant/lib/switch'
import VantToast from 'vant/lib/toast'
import 'vant/lib/checkbox/style'
import 'vant/lib/dialog/style'
import 'vant/lib/loading/style'
import 'vant/lib/picker/style'
import 'vant/lib/popup/style'
import 'vant/lib/pull-refresh/style'
import 'vant/lib/slider/style'
import 'vant/lib/switch/style'
import 'vant/lib/toast/style'
Vue.use(Region)
Vue.prototype.$ELEMENT = { size: 'mini' }
Vue.use(ElementSwitch)
Vue.use(ElementDatePicker)
Vue.prototype.$alert = MessageBox.alert

/**
 * 显示自动关闭的全局提示
 * @param {string|Object} options 提示文案或 Element Message 配置
 * @param {string} type 提示类型
 * @returns {Object} Element Message 实例
 */
function showAutoMessage(options, type) {
  Message.closeAll()
  const normalized = typeof options === 'string' ? { message: options } : { ...(options || {}) }
  if (type) normalized.type = type
  return Message({
    duration: 1800,
    showClose: false,
    ...normalized
  })
}

/**
 * 创建全局提示方法
 * @returns {Function} 兼容 this.$message 和 this.$message[type] 的方法
 */
function createAutoMessage() {
  const autoMessage = options => showAutoMessage(options)
  ;['success', 'warning', 'info', 'error'].forEach(type => {
    autoMessage[type] = options => showAutoMessage(options, type)
  })
  autoMessage.closeAll = Message.closeAll
  return autoMessage
}

Vue.prototype.$message = createAutoMessage()
Vue.use(VantCheckbox)
Vue.use(VantDialog)
Vue.use(VantLoading)
Vue.use(VantPicker)
Vue.use(VantPopup)
Vue.use(VantPullRefresh)
Vue.use(VantSlider)
Vue.use(VantSwitch)
Vue.use(VantToast)
Vue.config.productionTip = false

/**
 * 功能：创建并挂载前端应用。
 * 参数：无。
 * @returns {Vue} 已挂载的 Vue 应用实例。
 */
function mountApplication() {
  return new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}

mountApplication()
